"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CashBackIcon = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _rebrand = require("../../../../icons-react/rebrand");
var _excluded = ["size"];
var SIZES = {
  s: {
    width: 12
  },
  m: {
    width: 14
  },
  l: {
    width: 16
  }
};
var StyledCashBackIcon = (0, _styledComponents["default"])(function (_ref) {
  var size = _ref.size,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_rebrand.Cashback, (0, _extends2["default"])({}, SIZES[size], rest));
}).withConfig({
  displayName: "CashBackIcon__StyledCashBackIcon",
  componentId: "sc-1r717fv-0"
})(["path{fill:url(#cashback_svg__a) !important;}"]);
var CashBackIcon = exports.CashBackIcon = function CashBackIcon(_ref2) {
  var _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 'm' : _ref2$size;
  return /*#__PURE__*/_react["default"].createElement(StyledCashBackIcon, {
    size: size
  });
};